import AppProvider from './AppProvider';
import { useInitLanguage } from './hooks/i18n/useInitLanguage';
import './i18n/config';
import AppRouter from './routing/AppRouter';

function App() {
  useInitLanguage();

  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
}

export default App;
